module.exports = new __parcel__URL__("defense_log_tab.a71b5cdc.png").toString();